import { Box, Typography, Card, CardContent, IconButton, useTheme } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { keyframes } from '@emotion/react';

// Arrow animation
const arrowAnimation = keyframes`
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(5px);
    }
    100% {
        transform: translateY(0);
    }
`;

const ArrowTeaser = () => {
    const theme = useTheme(); // Access the theme

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 3,
                height: '100%', // Ensure it takes full height if needed
                position: 'relative',
            }}
        >
            <Card
                sx={{
                    width: '100%', // Full width or a specific size
                    maxWidth: 400,
                    textAlign: 'center',
                    borderRadius: 2,
                    marginBottom: 2, // Space between card and arrow
                    background: `linear-gradient(to right, ${theme.palette.secondary.light}, ${theme.palette.primary.main})`, // Use theme colors for gradient
                    boxShadow: 10,
                    color: theme.palette.primary.contrastText, // Use theme for text color
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        sx={{
                            mb: 1,
                            fontWeight: 'bold',
                        }}
                    >
                        📝 No history available.
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.palette.primary.contrastText, // Ensure this matches the defined text color
                            fontSize: '1.1rem', // Slightly larger for emphasis
                            lineHeight: 1.5,
                        }}
                    >
                        Start typing below or copy-paste content to ask anything
                    </Typography>
                </CardContent>
            </Card>

            {/* Arrow Indicator */}
            <IconButton
                sx={{
                    animation: `${arrowAnimation} 1s infinite`, // Animation for the arrow
                    backgroundColor: "secondary.light",
                    color: "primary.contrastText", // Match arrow color with text color
                    '&:hover': {
                        backgroundColor: "secondary.main",
                        transform: 'scale(1.2)', // Slight scale on hover for effect
                    },
                }}
            >
                <ArrowDownwardIcon fontSize="large" />
            </IconButton>
        </Box>
    );
};

export default ArrowTeaser;
